import React from 'react';
import {Plan} from '../types/Plan';
import {getFormattedNumber} from '../utils/NumberUtils';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCaretDown, faCaretUp} from '@fortawesome/free-solid-svg-icons';

interface StromDetailProps {
    plan: Plan;
    skutecnost: boolean;
}

export const StromDetail: React.FC<StromDetailProps> = ({plan, skutecnost}) => {
    const diffLabel = plan.schvalenyRozpocet < plan.upravenyRozpocet ? 'navýšeno' : 'poníženo';

    if (skutecnost) {
        const procenta = Math.round((plan.skutecnnost / plan.upravenyRozpocet) * 100);
        const rozdil = plan.upravenyRozpocet - plan.skutecnnost;

        return (
            <div>
                <h2>{plan.nazevAkce}</h2>
                <div className="smaller-text">{plan.popisAkce}</div>
                <div>Skutečnost:</div>
                <div className="bigger-text">{getFormattedNumber(plan.skutecnnost)} tis. Kč</div>
                <div>
                    Vydáno {procenta}% z upraveného rozpočtu (zbývá {getFormattedNumber(rozdil)} tis. Kč).
                </div>
                <div>
                    Upravený rozpočet: <strong>{getFormattedNumber(plan.upravenyRozpocet)} tis. Kč</strong>
                </div>
            </div>
        );
    }

    let icon;
    if (plan.rozdil < 0) {
        icon = <FontAwesomeIcon icon={faCaretDown} style={{marginRight: 8}} />;
    } else if (plan.rozdil > 0) {
        icon = <FontAwesomeIcon icon={faCaretUp} style={{marginRight: 8}} />;
    }

    return (
        <div>
            <h2>{plan.nazevAkce}</h2>
            <div className="smaller-text">{plan.popisAkce}</div>
            <div>Upravený rozpočet:</div>
            <div className="bigger-text">
                {icon}
                {getFormattedNumber(plan.upravenyRozpocet)} tis. Kč
            </div>
            {plan.rozdil === 0 ? (
                <div>Plánovaný výdaj nebyl změněn.</div>
            ) : (
                <div>
                    Plánovaný výdaj upraven o {plan.procento * 100}% proti schválenému rozpočtu ({diffLabel} o {getFormattedNumber(Math.abs(plan.rozdil))} tis.
                    Kč).
                </div>
            )}
            <div>
                Schválený rozpočet: <strong>{getFormattedNumber(plan.schvalenyRozpocet)} tis. Kč</strong>
            </div>
        </div>
    );
};
